let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("a4Sf9"), load("7Q0UC"), load("i0gb6"), load("g7QTt"), load("bCr24")]).then(() => parcelRequire('arPKr'));